import { loadable } from '@shared/core/loadableFromNamedExport';

// The verify-email dialog only opens when a user attempts to publish with an unverified email.
// Consumers gate its render behind `dialogProps.isOpen`, so this chunk loads on demand rather
// than sitting in every publish surface's bundle.
export const LazyEmailVerificationDialog = loadable(
  () => import(/* webpackChunkName: "shared/email-verification-dialog" */ './EmailVerificationDialog'),
  'EmailVerificationDialog',
);
